import { Box, styled, Grid, TableRow, TableCell, Button, Switch } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import { Link, useNavigate } from 'react-router-dom';
import { EmailStep, EmailTemplate } from '../../../schema/email_template';
import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';

const tableHead = ['สถานะ', 'ขั้นตอน', 'เรื่อง', 'ถึง', 'action'];

const EmailTemplatePage: React.FC = () => {
  const navigate = useNavigate();
  // const [stepList, setStepList] = useState<EmailStep[]>([]);
  const [data, setData] = useState<TableResponse<EmailTemplate> | null>(null);

  // const [filterStep, setFilterStep] = useState<string>('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const toggleActive = (email_template_id: string | number, is_active: boolean) => {
    if (!data) {
      return;
    }
    const emailTemplate = data?.data.find((data) => data.id == email_template_id);
    if (emailTemplate) {
      api
        .patch<EmailStep[]>(`/email_template/${email_template_id}`, {
          is_active: is_active
        })
        .then(() => {
          navigate('/email-management');
        });
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams();
    // if (filterStep) {
    //   searchParams.set('step_id', `${filterStep}`);
    // }
    searchParams.set('offset', `${page * rowsPerPage}`);
    searchParams.set('limit', `${rowsPerPage}`);

    api
      .get<TableResponse<EmailTemplate>>(`/email_template/table`, { params: searchParams })
      .then((res) => {
        const { data } = res;
        setData(data);
      });
  }, [page, rowsPerPage]);

  // useEffect(() => {
  //   api.get<EmailStep[]>(`/email_step`).then((res) => {
  //     const { data } = res;
  //     setStepList(data);
  //   });
  // }, []);

  return (
    <Container>
      <PageHeader text="รูปแบบ E-mail" />
      <Grid container spacing={2} marginTop={1}>
        {/* <Grid item md={4}>
          <Autocomplete
            limitTags={2}
            disablePortal
            options={stepList}
            getOptionLabel={(option) => `${option.step_name}`}
            renderInput={(params) => <TextField {...params} label="ขั้นตอน" fullWidth />}
            onChange={(_, value) => setFilterStep(value ? value.id.toString() : '')}
            fullWidth
          />
        </Grid> */}
        {/* <Grid item md sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            component={Link}
            to={`/email-management/create`}
            variant="contained"
            color="primary"
          >
            เพิ่มข้อมูล
          </Button>
        </Grid> */}
      </Grid>

      <Box sx={{ padding: '16px 0' }}>
        <Table
          heads={tableHead}
          count={data?.total ? data.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((data, index) => (
            <TableRow key={index}>
              <TableCell align="center">
                <Switch
                  defaultChecked={data.is_active}
                  onChange={() => toggleActive(data.id, !data.is_active)}
                />
              </TableCell>
              <TableCell align="center">{data.step.step_name}</TableCell>
              <TableCell align="center">{data.subject}</TableCell>
              <TableCell align="center">{data.recipient.recipient_name}</TableCell>
              <TableCell align="center">
                <Button
                  component={Link}
                  to={`/email-management/${data.id}/edit`}
                  variant="contained"
                  color="warning"
                >
                  แก้ไข
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Container>
  );
};

export default EmailTemplatePage;

const Container = styled('div')`
  padding: 24px;
`;
